import { Routes } from '@angular/router';

import { EntryComponent } from './entry.components';
import { LoginComponent } from './login/login.component';
import { ForgotPWComponent } from './forgotpw/forgotpw.component';
import { MessageComponent } from './message/message.component';
import { ResetPWComponent } from './reset-password/reset-password.component';
import { ExistingAccountComponent } from './existing-account/existing-account.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { LoginUserComponent } from './login-user/login-user.component';
import { InvitedComponent } from './invited/invited.component';
import { FirstLoginComponent } from './first-login/first-login.component';
import { alreadyLoggedGuard } from 'directives/already-logged.guard';
import { firstLoginResolver } from './first-login/first-login-resolver.service';
import { LogoutComponent } from 'pages/entry/logout/logout.components';
import { SelfEnrollmentFirstLoginComponent } from './self-enrollment-first-login/self-enrollment-first-login.component';
import { SelfEnrollmentLoginComponent } from 'pages/entry/self-enrollment-login/self-enrollment-login.component';
import { selfEnrollmentFirstLoginResolver } from './self-enrollment-first-login/self-enrollment-first-login.resolver';
import { MemberSuiteLoginComponent } from 'pages/entry/member-suite-login/member-suite-login.component';
import { MemberClicksLoginComponent } from 'pages/entry/member-clicks-login/member-clicks-login.component';
import { selfEnrollmentFirstLoginGuard } from 'pages/entry/self-enrollment-first-login/self-enrollment-first-login.guard';
import { ChangeEmailComponent } from 'pages/entry/change-email/change-email.component';
import { externalRedirectGuard } from 'components/external-redirect/external-redirect.guard';

export const routing: Routes = [
  {
    path: '',
    component: EntryComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent,
        canActivate: [alreadyLoggedGuard],
      },
      {
        path: 'member-suite-login',
        component: MemberSuiteLoginComponent,
      },
      {
        path: 'member-clicks-login',
        component: MemberClicksLoginComponent,
      },
      {
        path: 'logout',
        component: LogoutComponent,
      },
      {
        path: 'registration',
        component: LoginComponent,
        canActivate: [externalRedirectGuard],
        data: {
          externalUrl: 'https://www.certemy.com/',
        },
      },
      {
        path: 'invited/:hash',
        component: InvitedComponent,
      },
      {
        path: 'forgotpw',
        component: ForgotPWComponent,
      },
      {
        path: 'reset-password/:token/:email',
        component: ResetPWComponent,
      },
      {
        path: 'message',
        component: MessageComponent,
      },
      {
        path: 'existing-account',
        component: ExistingAccountComponent,
      },
      {
        path: 'verify-email/:token',
        component: VerifyEmailComponent,
      },
      {
        path: 'login-user/:token/:role',
        component: LoginUserComponent,
      },
      {
        path: 'register-as/:role',
        redirectTo: '/entry/login',
      },
      {
        path: 'first-login/:role',
        component: FirstLoginComponent,
        resolve: {
          info: firstLoginResolver,
        },
      },
      {
        path: 'self-enrollments/:title/:token',
        component: SelfEnrollmentFirstLoginComponent,
        resolve: {
          registerData: selfEnrollmentFirstLoginResolver,
        },
      },
      {
        path: 'self-enrollments/:title/:token/login',
        component: SelfEnrollmentLoginComponent,
        canActivate: [selfEnrollmentFirstLoginGuard],
      },
      {
        path: 'change-email/:token',
        component: ChangeEmailComponent,
      },
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
    ],
  },
];
